import {
  ApiResponse,
  CCApiResponse,
  IChannel,
  ILayoutType,
  IViewChannel,
} from 'src/interfaces';
import { getScreenConfigurationLabel } from 'src/utils';

export const mapAllChannels = (channels: unknown[]): IChannel[] => {
  return channels.map((channel: unknown) => {
    return mapChannel(channel);
  });
};

const mapChannel = (channel: any): IChannel => {
  return {
    id: channel.id,
    name: channel.attributes.name,
  };
};

export const mapViewChannels = (
  response: CCApiResponse,
  layoutTypes: ILayoutType[] = [],
): IViewChannel[] => {
  return response.data.map((item: ApiResponse) => ({
    ...item,
    screenConfigurationLabel: getScreenConfigurationLabel(item.screens),
    layoutType: layoutTypes.find(
      (layoutType) => layoutType.id === item.layout_type_id[0],
    ),
  }));
};

export const mapViewChannel = (
  channel: ApiResponse,
  layoutTypes: ILayoutType[] = [],
): IViewChannel => {
  return {
    channel_name: channel.channel_name,
    screens: channel.screens,
    layout_type_id: channel.layout_type_id,
    layoutType: layoutTypes.find(
      (layoutType) => layoutType.id === channel.layout_type_id[0],
    ),
    screenConfigurationLabel: getScreenConfigurationLabel(channel.screens),
  };
};

export const sortResponse = (response: CCApiResponse): CCApiResponse => {
  response.data.sort((a: any, b: any) =>
    a.channel_name.localeCompare(b.channel_name),
  );

  return response;
};
